<div class="home-page">
  <header class="home-header">
    <div>
      <h2 class="home-greeting">
        {{ 'home.greeting' | translate:{ name: greetingName } }}
      </h2>
    </div>

    <a [routerLink]="routes.ajoutLogements" class="home-action-btn">
      <fa-icon icon="plus"></fa-icon>
      {{ 'home.addLogement' | translate }}
    </a>
  </header>

  <section class="home-section">
    <div class="home-section-header">
      <h3>{{ 'home.todoTitle' | translate }}</h3>
      <span class="home-soon-badge">{{ 'home.comingSoon' | translate }}</span>
    </div>

    <div class="home-todo-card home-todo-card--disabled">
      <p class="home-empty">{{ 'home.todoEmpty' | translate }}</p>
    </div>
  </section>

  <section class="home-section">
    <div class="home-section-header">
      <h3>{{ 'home.overviewTitle' | translate }}</h3>
      <span class="home-soon-badge">{{ 'home.comingSoon' | translate }}</span>
    </div>

    <div class="home-kpi-row home-kpi-row--disabled">
      @for (kpi of kpiCards; track kpi) {
        <div class="home-kpi">
          <span class="home-kpi-label">{{ kpi.label | translate }}</span>
          <span class="home-kpi-value">{{ kpi.value | translate }}</span>
        </div>
      }
    </div>
  </section>
</div>
